import React, { useEffect, useState, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';

interface IProps {
  title: string,
}
interface IState { }

const Sub = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { title } = props;

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section className='pdf-sub-title-warp'>
      <p className='pdf-sub-title'>{title}</p>
    </section>
  );
};

export default observer(Sub);
